'use strict';

export class ProjectSignCtrl
{
	$scope;
	$filter;
	$mdDialog;
	cfg;
	
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.cfg = jsDataService.get('cfgSign', {});
	}
	
	actSign(ev){
		const postElements = {
			code: ''
		};
		
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "$filter", 'notify', 'postElements', 'cfg', this.signCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'esfasi/ng_sign.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				postElements: postElements,
				cfg: {
					codeUrl: this.cfg.codeUrl,
					dialogTitle: this.cfg?.signTitle,
					submitButton: this.cfg?.signButton,
				}
			}
		}).then((results) => {
			if(this.cfg?.signUrl){
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.signUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}
	
	actReturn(ev){
		this.commentDialog(ev, {
			mandatory: this.cfg?.returnMandatory,
			dialogTitle: this.cfg?.returnTitle,
			explain: this.cfg?.returnExplain,
			submitButton: this.cfg?.returnButton,
			submitUrl: this.cfg?.returnUrl
		});
	}
	
	actRefuse(ev){
		this.commentDialog(ev, {
			mandatory: this.cfg?.refuseMandatory,
			dialogTitle: this.cfg?.refuseTitle,
			explain: this.cfg?.refuseExplain,
			submitButton: this.cfg?.refuseButton,
			submitUrl: this.cfg?.refuseUrl
		});
	}
	
	commentDialog(ev, cfg){
		const postElements = {
			comment: ''
		};
		
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "$filter", 'postElements', 'cfg', this.commentCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'esfasi/ng_comment.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				postElements: postElements,
				cfg: cfg
			}
		}).then((results) => {
			if(cfg.submitUrl){
				this.$scope.basicHttpConfigProcess({
					url: cfg.submitUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}
	
	commentCtrl($scope,$mdDialog, $filter, postElements, cfg){
		$scope.cfg = cfg;
		$scope.postElements = postElements;
		if(typeof($scope.cfg.dialogTitle) === 'undefined'){
			$scope.cfg.dialogTitle = $filter('tr')('comment_dialog_title');
		}
		if(typeof($scope.cfg.submitButton) === 'undefined'){
			$scope.cfg.submitButton = $filter('tr')('submit_button');
		}
		
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function() {
			$mdDialog.hide($scope.postElements);
		};
	}
	
	signCtrl($scope,$mdDialog, $filter, notify, postElements, cfg){
		$scope.codeRequested = false;
		$scope.gettingCode = false;
		$scope.postElements = postElements;
		$scope.cfg = cfg;
		
		$scope.getCode = function(ev){
			$scope.gettingCode = true;
			if($scope.cfg.codeUrl && $scope.cfg.codeUrl !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: $scope.cfg.codeUrl,
					method: 'GET',
				}).then((response) => {
					if(response.data.success){
						$scope.codeRequested = true;
					}
					$scope.gettingCode = false;
				}, () => {});
			}
		};
		
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function() {
			$mdDialog.hide($scope.postElements);
		};
	}
}